export default "__VITE_ASSET__F5e1D9Fp__"